type DwellFlush = (eventId: string, durationMs: number) => void;

interface ActiveDwell {
  eventId: string;
  path: string;
  accumulatedMs: number;
  visibleSince: number | null;
  lastFlushedMs: number;
}

let active: ActiveDwell | null = null;
let flush: DwellFlush | null = null;
let listenersBound = false;

const now = () => (typeof performance !== "undefined" ? performance.now() : Date.now());

function isVisible() {
  return typeof document !== "undefined" && document.visibilityState === "visible";
}

function settle() {
  if (!active) return;
  if (active.visibleSince !== null) {
    active.accumulatedMs += now() - active.visibleSince;
    active.visibleSince = isVisible() ? now() : null;
  } else if (isVisible()) {
    active.visibleSince = now();
  }
}

function flushActive() {
  if (!active || !flush) return;
  settle();
  const total = Math.round(active.accumulatedMs);
  if (total >= 1000 && total > active.lastFlushedMs) {
    active.lastFlushedMs = total;
    flush(active.eventId, total);
  }
}

function bindListeners() {
  if (listenersBound || typeof window === "undefined") return;
  listenersBound = true;
  document.addEventListener("visibilitychange", () => {
    if (!active) return;
    if (document.visibilityState === "hidden") {
      flushActive();
      if (active) active.visibleSince = null;
    } else if (active.visibleSince === null) {
      active.visibleSince = now();
    }
  });
  window.addEventListener("pagehide", flushActive);
  window.addEventListener("beforeunload", flushActive);
}

export function configurePageDwell(handler: DwellFlush) {
  flush = handler;
  bindListeners();
}

export function beginPageDwell(eventId: string, path: string) {
  if (active && active.path === path && active.eventId === eventId) return;
  if (active) flushActive();
  active = { eventId, path, accumulatedMs: 0, visibleSince: isVisible() ? now() : null, lastFlushedMs: 0 };
}

export function endPageDwell(nextPath?: string) {
  if (!active) return;
  if (nextPath && active.path === nextPath) return;
  flushActive();
  active = null;
}
